// extracted by mini-css-extract-plugin
export var changeIcon = "_5t-4";
export var container = "_5t-0";
export var divider = "_5t-7";
export var externalLinkIcon = "_5t-1";
export var green = "_5t-5";
export var helpCircleIcon = "_5t-3";
export var iconButton = "_5t-2";
export var red = "_5t-6";